import apiClient from './apiClient';

const STATUS_MAP = { OPEN: 'flagged', ACKNOWLEDGED: 'investigating', RESOLVED: 'blocked', FALSE_POSITIVE: 'blocked' };

export async function fetchThreatEvents(count = 80) {
  const { data } = await apiClient.get('/threats/alerts', { params: { limit: count } });
  return data.map((a) => ({
    ...a,
    timestamp: a.created_at,
    type: String(a.detector || '').replaceAll('_', ' '),
    severity: String(a.severity || '').toLowerCase(),
    sourceIp: a.source_ip,
    country: a.country || '—',
    target: a.matched_signature || a.summary || '—',
    rawStatus: a.status,
    status: STATUS_MAP[a.status] || String(a.status || '').toLowerCase()
  }));
}

// The backend takes `status` as a query param on this one endpoint (unlike
// the JSON-body status updates elsewhere in this platform, e.g. Email
// Security findings/dark web mentions) — see threat-detection-service
// app/api/v1/alerts.py update_alert_status.
export async function updateAlertStatus(id, status) {
  const { data } = await apiClient.patch(`/threats/alerts/${id}/status`, undefined, { params: { status } });
  return data;
}

// Used to simulate a real-time push (e.g. from a WebSocket / SSE channel later).
export function nextSimulatedEvent() {
  return generateThreatEvent();
}
